// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};
  InstantSearchApi.beforeCall = function(eventType, eventInfo) {
  if (Shopify && Globals) {
        Globals.instantSearchQueryParams.currency = Shopify.currency.active
        Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate
        Globals.instantSearchQueryParams.country = Shopify.country
  }
  }
})();